// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__1tCwy","closeButton":"Modal_closeButton__sf80b"};